import { IconBrandAmazon } from "@tabler/icons-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { i18n } from "@/i18n";
import { api } from "@/lib/api";

export const Route = createFileRoute("/auth/amazon/callback")({
  component: AmazonCallbackPage,
});

function AmazonCallbackPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("auth");
  const [error, setError] = useState<string | null>(null);
  // Guard against StrictMode double-invoke: the OAuth code/state are single-use,
  // so the exchange must run exactly once even if the effect fires twice.
  const exchangedRef = useRef(false);

  useEffect(() => {
    if (exchangedRef.current) return;
    exchangedRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!code || !state) {
      // 全局 i18n 实例：避免把 t 加进 effect 依赖（exchange 只能执行一次）
      setError(i18n.t("auth:callback.missingParams"));
      return;
    }

    api
      .post("auth/oauth/amazon/exchange", { json: { code, state } })
      .json<{ success: boolean }>()
      .then(({ success }) => {
        if (success) navigate({ to: "/" });
        else setError(i18n.t("auth:callback.loginFailed"));
      })
      .catch((err) => {
        console.error("Amazon OAuth exchange failed", err);
        setError(i18n.t("auth:callback.loginFailed"));
      });
  }, [navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-4">
        <div className="flex flex-col items-center gap-4 text-center">
          <p className="text-destructive-foreground">{error}</p>
          <button
            type="button"
            className="text-sm text-muted-foreground underline underline-offset-4"
            onClick={() => navigate({ to: "/login" })}
          >
            {t("callback.backToLogin")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="flex flex-col items-center gap-4 text-center">
        <IconBrandAmazon className="size-10 text-muted-foreground animate-pulse" />
        <p className="text-muted-foreground">{t("callback.signingIn")}</p>
      </div>
    </div>
  );
}
